var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mb-3",attrs:{"id":"loading-div"}},[_c('b-spinner',{attrs:{"variant":"light","id":"loading-spinner","label":"Loading..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }